import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import "../styles/noticias.css";
import {
  Card,
  CardMedia,
  CardContent,
  Typography,
  Avatar,
} from "@mui/material";
import heroNoticias from "../assets/news/banner-noticias.png";
import api from "../services/api";

const ITEMS_PER_PAGE = 12;

const formatFecha = (isoDate) => {
  const fecha = new Date(isoDate);
  return fecha.toLocaleDateString("es-BO", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};

export default function Noticias() {
  const navigate = useNavigate();
  const [noticias, setNoticias] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    const fetchNoticias = async () => {
      const res = await api.get("/noticias/");
      const data = res.data.map((n) => ({
        id: n.id,
        titulo: n.titulo,
        categoria: n.categoria,
        descripcion: n.noticia,
        imagen: n.imagen,
        autores: ["ABIS La Paz"],
        fecha: formatFecha(n.updated_at),
      }));
      setNoticias(data);
    };

    fetchNoticias();
  }, []);

  const destacadas = noticias.slice(0, 2);
  const restantes = noticias.slice(2);

  const totalPages = Math.ceil(restantes.length / ITEMS_PER_PAGE);
  const start = (page - 1) * ITEMS_PER_PAGE;
  const paginated = restantes.slice(start, start + ITEMS_PER_PAGE);

  return (
    <div className="noticias-container">
      {/* HERO */}
      <section
        className="hero-noticias"
        style={{ backgroundImage: `url(${heroNoticias})` }}
      >
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <div className="hero-text">
            <h1>Información Oficial y Actividades Institucionales</h1>
            <p>
              Conoce las últimas iniciativas, proyectos y pronunciamientos de
              ABIS La Paz. Difundimos contenido relevante para nuestros
              asociados y la comunidad técnica.
            </p>
          </div>
        </div>
      </section>

      <div className="noticias-content">
        {/* DESTACADAS */}
        <div className="noticias-destacadas">
          {destacadas.map((noticia) => (
            <Card
              key={noticia.id}
              className="noticia-card destacada"
              onClick={() => navigate(`/noticias/${noticia.id}`)}
              sx={{ cursor: "pointer" }}
            >
              <CardMedia
                component="img"
                height="240"
                image={noticia.imagen}
                alt={noticia.titulo}
                loading="lazy"
              />
              <CardContent>
                <Typography variant="caption" className="categoria">
                  {noticia.categoria}
                </Typography>
                <Typography variant="h6" className="titulo">
                  {noticia.titulo}
                </Typography>
                <Typography variant="body2" className="descripcion">
                  {noticia.descripcion}
                </Typography>
                <div className="autores-fecha">
                  <div className="autores">
                    <Avatar sx={{ width: 24, height: 24 }}>A</Avatar>
                    <span>ABIS La Paz</span>
                  </div>
                  <span className="fecha">{noticia.fecha}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* OTRAS NOTICIAS */}
        <div className="otras-noticias">
          {paginated.map((noticia) => (
            <Card
              key={noticia.id}
              className="noticia-card"
              onClick={() => navigate(`/noticias/${noticia.id}`)}
              sx={{ cursor: "pointer" }}
            >
              <CardMedia
                component="img"
                height="180"
                image={noticia.imagen}
                alt={noticia.titulo}
                loading="lazy"
              />
              <CardContent>
                <Typography variant="caption" className="categoria">
                  {noticia.categoria}
                </Typography>
                <Typography variant="h6" className="titulo">
                  {noticia.titulo}
                </Typography>
                <Typography variant="body2" className="descripcion">
                  {noticia.descripcion}
                </Typography>
                <div className="autores-fecha">
                  <div className="autores">
                    <Avatar sx={{ width: 24, height: 24 }}>A</Avatar>
                    <span>ABIS La Paz</span>
                  </div>
                  <span className="fecha">{noticia.fecha}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* PAGINACIÓN */}
        {totalPages > 1 && (
          <div className="pagination">
            <button disabled={page === 1} onClick={() => setPage(page - 1)}>
              Anterior
            </button>

            <span>
              Página {page} de {totalPages}
            </span>

            <button
              disabled={page === totalPages}
              onClick={() => setPage(page + 1)}
            >
              Siguiente
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
